import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import { membershipHighlightedFeaturesJadeData } from '@/app/[locale]/membership/_data/membershipHighlightedFeaturesData';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import RichText from '@/app/components/RichText';
import { LEGAL_FOOTNOTES_ID } from '@/app/consts/ids';

const footnoteLink = () => (
  <sup>
    <a href={`#${LEGAL_FOOTNOTES_ID}`}>*</a>
  </sup>
);

const MembershipFeatures = () => {
  const t = useTranslations();

  return (
    <section
      className="relative pt-10 pb-14 md:px-5 md:pb-20 lg:pt-12 lg:pb-24"
      data-cy="membership-features"
    >
      <LayoutGrid className="h-full content-between">
        <GridItem
          colStart={{ sm: 'main', md: 3, lg: 3 }}
          colEnd={{ sm: 'main', md: 23, lg: 23 }}
        >
          <Typography
            Element="h2"
            variant="h3"
            className="mb-10 text-3xl md:mb-14 lg:text-5xl"
            height="normal"
            data-cy="membership-features-title"
          >
            {t('membership_features_title')}
          </Typography>
        </GridItem>

        <GridItem
          colStart={{ sm: 'main', md: 3, lg: 3 }}
          colEnd={{ sm: 'main', md: 23, lg: 23 }}
          className="relative"
        >
          <div className="grid gap-y-8 md:grid-cols-2 md:gap-9 lg:grid-cols-4">
            {membershipHighlightedFeaturesJadeData.map((feature) => (
              <div className="flex flex-col" key={feature.id}>
                <div
                  className="relative mb-3 aspect-2000/2667 w-full"
                  data-cy={`membership-features-image-${feature.id}`}
                >
                  <ArtDirectionImage
                    srcSet={[
                      {
                        src: feature.image.src,
                      },
                    ]}
                    alt={t(feature.image.alt)}
                    sizes="(max-width: 768px) 80vw,(max-width: 1200px) 50vw, 25vw"
                    fill
                    className="rounded-3xl object-cover"
                  />
                </div>
                <div>
                  <Typography
                    data-cy={`membership-features-text-${feature.id}`}
                  >
                    <RichText
                      messageKey={feature.text}
                      tValues={{ footnoteLink }}
                    />
                  </Typography>
                </div>
              </div>
            ))}
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default MembershipFeatures;
